<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    :esg-subscription="esgSubscription"
    :prices-assessment-subscription="subscription"
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
      :esg-subscription="esgSubscription"
      :prices-assessment-subscription="subscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  LITHIUM,
  SUBSCRIPTION_ESG_LITHIUM,
  SUBSCRIPTION_FORECASTS_LITHIUM,
  SUBSCRIPTION_PRICE_ASSESSMENTS_LITHIUM,
} from '~/constants/services/constants'
import lithiumData from '~/constants/data-reports/lithium'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(LITHIUM)
const productData = ref(lithiumData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_LITHIUM)
const esgSubscription = ref(SUBSCRIPTION_ESG_LITHIUM)
const subscription = ref(SUBSCRIPTION_PRICE_ASSESSMENTS_LITHIUM)

const seoByPages = {
  'price-assessments': {
    title: 'Lithium Price Assessments',
    description:
      'Benchmark Lithium Price Assessments provide regular prices published to the highest IOSCO standard to support lithium supply contract settlement, indexation and price risk management.',
  },
  forecast: {
    title: 'Lithium Price Forecasts',
    description:
      "Benchmark's lithium price forecasts enable strategic decisions across the battery supply chain by indicating the future direction of price movements.",
  },
  sustainability: {
    title: 'Lithium Sustainability Analysis',
    description:
      "Benchmarks's lithium sustainability analysis provides transparency into the ESG performance and approach of lithium producers worldwide. Gain clarity into the key ESG trends occuring in upstream lithium supply.",
  },
}

const { params } = useRoute()
const { getSeoInfo } = useSeo()
const seo = getSeoInfo(seoByPages[params.slug || 'price-assessments'])
useHead(seo)
</script>
